define('SearchSpring.Facets.Model', [
    'SearchSpring.Facets.ApiParameters',
    'SearchSpring.Mapper.Facets',
    'SearchSpring.Mapper.Item',
    'SC.Configuration',
    'Item.Collection',
    'Profile.Model',
    'Backbone.CachedModel',
    'Backbone',
    'underscore',
    'jQuery',
    'Utils'
], function FacetsSearchSpringModel(
    ApiParams,
    mapFacets,
    mapItem,
    Configuration,
    ItemCollection,
    ProfileModel,
    CachedModel,
    Backbone,
    _,
    jQuery,
    Utils
) {
    var originalFetch = CachedModel.prototype.fetch;

    return CachedModel.extend({
        urlRoot: Configuration.get('searchspring.baseUrl').split('[SITEID]').join(Configuration.get('searchspring.siteId')),
        initialize: function initialize() {
            this.on('change:items', function onChangeItems(model, items) {
                if (!(items instanceof ItemCollection)) {
                    // NOTE: Compact is used to filter null values from response
                    model.set('items', new ItemCollection(_.compact(items)));
                }
            });
        },

        // @method fetch overrides fetch so we make sure that the cache is set to true, so we wrap it
        fetch: function fetch(options) {
            Utils.deepExtend(options || {}, this.options);
            if (options.cache === undefined) {
                options.cache = true;
            }
            options.data = options.data || {};

            options.cache = !this.ignoreCache;
            this.force_avoid_redirect = options && options.data && options.data.force_avoid_redirect;
            return originalFetch.apply(this, arguments);
        },

        sync: function sync(method, collection, options) {
            var cachedModel;
            var url;
            // This is a fix to not cancell the request if the new url is the same as a cached one that has not finished.
            if (SC.ENVIRONMENT.jsEnvironment === 'browser') {
                url = _.result(this, 'url');
                if (options && options.data) {
                    url += ((url.indexOf('?') !== -1) ? '&' : '?') + jQuery.param(options.data);
                }

                cachedModel = Backbone.localCache[url];
                if (!!cachedModel && !cachedModel.status) {
                    cachedModel.killerId = options.killerId;
                }

                options.dataType = 'jsonp';
                options.jsonpCallback = 'jsonpCallback' + Math.round(Math.random() * 100000);
            }
            return CachedModel.prototype.sync.apply(this, arguments);
        },
        parse: function parse(response) {
            var profile = ProfileModel.getInstance();
            var store = profile.get('store');
            var excludedFacets = Configuration.get('facetsExtra.exclude') || [];
            var facetData = Configuration.get('facets') || [];
            var pricelevel = profile.get('priceLevel');
            var defaultPricelevel = SC.ENVIRONMENT.siteSettings.defaultpricelevel;
            var priceLevelMapping = Configuration.get('searchspring.priceLevelMapping') || [];
            response.items = _.map(response.results, function onMap(item) {
                return mapItem(item);
            });
            response.facets = _.map(response.facets, function onMapFacets(facet) {
                return mapFacets(facet);
            });
            response.facets = _.filter(response.facets, function filterFacets(f) {
                var facetInfo = _.findWhere(facetData, { id: f.field });
                var priceFacet;
                var priceLevelFacet = _.findWhere(priceLevelMapping, { searchspringid: f.field });

                if (pricelevel !== defaultPricelevel && priceLevelFacet && priceLevelFacet.netsuiteid === pricelevel) {
                    if (store && store.get('priceField')) {
                        priceFacet = _.findWhere(facetData, { id: store.get('priceField').toLowerCase() });
                        if (priceFacet) {
                            priceFacet.id = f.field;
                        }
                    }

                    return true;
                }

                if (pricelevel !== defaultPricelevel && priceLevelFacet && priceLevelFacet.netsuiteid !== pricelevel) {
                    return false;
                }

                if (pricelevel !== defaultPricelevel && f.field === store.get('priceField').toLowerCase()) {
                    return false;
                }

                return facetInfo && (!facetInfo.storeId || !store || facetInfo.storeId + '' === store.get('internalid') + '')
                    && excludedFacets.indexOf(f.field) === -1;
            });
            response.total = response.pagination && response.pagination.totalResults;
            response.isSearchSpring = true;
            return response;
        }
    });
});
